var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 24L38 0.000102997",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2929 34.7071C37.6834 35.0976 38.3166 35.0976 38.7071 34.7071L45.0711 28.3431C45.4616 27.9526 45.4616 27.3195 45.0711 26.9289C44.6805 26.5384 44.0474 26.5384 43.6569 26.9289L38 32.5858L32.3431 26.9289C31.9526 26.5384 31.3195 26.5384 30.9289 26.9289C30.5384 27.3195 30.5384 27.9526 30.9289 28.3431L37.2929 34.7071ZM37 22L37 34L39 34L39 22L37 22Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0002 52.5L39.0002 52.5L39.0002 52.5L38.0002 52.5ZM38.7073 46.2929C38.3167 45.9024 37.6836 45.9024 37.2931 46.2929L30.9292 52.6569C30.5387 53.0475 30.5387 53.6806 30.9292 54.0712C31.3197 54.4617 31.9529 54.4617 32.3434 54.0711L38.0002 48.4142L43.6571 54.071C44.0476 54.4615 44.6808 54.4615 45.0713 54.071C45.4618 53.6805 45.4618 53.0473 45.0713 52.6568L38.7073 46.2929ZM39 59L39.0002 52.5L37.0002 52.5L37 59L39 59ZM39.0002 52.5L39.0002 47L37.0002 47L37.0002 52.5L39.0002 52.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58L38 80.9997",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclator);
export default __webpack_public_path__ + "static/media/eclator.7f2fcb33b40294df9fea8a89efa73cf3.svg";
export { ForwardRef as ReactComponent };